import type { NavigateFunction } from 'react-router';
import { UserRole } from '@/apolloClient.types';

// Create a reusable tick renderer for PolarAngleAxis labels that adds
// an outward radial offset to improve spacing between the radar and labels.
export const createRadialLabelTickRenderer = (
    offsetPx: number,
    options?: { fontSize?: number; fill?: string; fontWeight?: number | string }
) => {
    const { fontSize = 12, fill = 'var(--color-neutral-500)', fontWeight = 500 } = options || {};
    const RadialLabelTickRenderer = (props: any) => {
        const { x, y, cx, cy, payload, textAnchor } = props;
        const dx = x - cx;
        const dy = y - cy;
        const distance = Math.sqrt(dx * dx + dy * dy) || 1;
        const nx = x + (dx / distance) * offsetPx;
        const ny = y + (dy / distance) * offsetPx;

        return (
            <text x={nx} y={ny} fill={fill} fontSize={fontSize} fontWeight={fontWeight} textAnchor={textAnchor}>
                {payload.value}
            </text>
        );
    };

    return RadialLabelTickRenderer;
};

export const backToAssessments = (userRole: string, assessmentRunId: string, navigate: NavigateFunction) => {
    if (userRole === UserRole.Trainee || userRole === UserRole.Trainer) {
        navigate(`/content/assessments/${assessmentRunId || ''}`);
    } else {
        navigate('/contentmanagement/assessments');
    }
};
